import { render } from "./SupplyGettingDetail.vue?vue&type=template&id=c673b904&ts=true"
import script from "./SupplyGettingDetail.vue?vue&type=script&lang=ts"
export * from "./SupplyGettingDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__